import React, { useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import { Grid, Box, Card, CardHeader, CardContent, Avatar } from "@mui/material";
import { MdMarkEmailRead, MdMarkEmailUnread, MdMailOutline } from "react-icons/md";
import { indigo } from "@mui/material/colors";

import MessageTemplate from "../layout/MessageTemplate";
import RespondedTemplate from "../layout/RespondedTemplate";
import Flash from "../layout/Flash";
import CardComponent from "../layout/CardComponent";
import BottomNavigation from "../layout/BottomNavigation";
import * as CONST from "../Constants";

const propTypes = {
  state: PropTypes.object.isRequired,
  active: PropTypes.object.isRequired,
  old: PropTypes.object.isRequired,
  messages: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};
AdditionalMessagesPage.prototype = propTypes;
function AdditionalMessagesPage(props) {
  const [active, setActive] = useState(null);
  const [activeStep, setActiveStep] = React.useState(null);
  const [flashMessage, setFlashMessage] = useState(null);
  const [noMessages, showNoMessages] = useState(false);
  let { id } = useParams();
  let history = useHistory();

  React.useEffect(() => {
    const index = props.messages.findIndex((item) => (item.id == id ? item : null));
    if (index > -1) {
      setActive(props.messages[index]);
      setActiveStep(index);
      props.dispatch({ type: "set_active_message", payload: props.messages[index] });
    } else {
      if (props.active && !!props.messages.length > 0) {
        setActiveStep(0);
        setActive(props.messages[0]);
        history.push(`/patient_portal/additional_messages/${props.messages[0].id}`);
        props.dispatch({ type: "set_active_message", payload: props.messages[0] });
      } else {
        if (props.cpr_notifications.length > 0) {
          history.push(`/patient_portal/notifications/${props.cpr_notifications[0].id}`);
        } else {
          showNoMessages(true);
          setActive(null);
        }
      }
    }
    return () => {
      setActive(null);
      setActiveStep(null);
    };
  }, [props.messages, id]);

  const Carousel = () => {
    function handleStep(currentStep) {
      setActive(props.messages[currentStep]);
      props.dispatch({ type: "set_active_message", payload: props.messages[currentStep] });
      history.push(`/patient_portal/additional_messages/${props.messages[currentStep].id}`);
    }

    function handleNext() {
      const currentStep = activeStep + 1;
      setActiveStep(currentStep);
      handleStep(currentStep);
    }

    function handleBack() {
      const currentStep = activeStep - 1;
      setActiveStep(currentStep);
      handleStep(currentStep);
    }

    return (
      <>
        <Grid container direction="row" justifyContent="space-around" alignItems="center">
          <Grid item xs={12}>
            <Card className="patient-feed-card">
              <Box pt={2.5} pb={2} pl={2} pr={2}>
                <CardHeader
                  className="cpr"
                  avatar={
                    <Avatar
                      sx={{
                        color: active.status == "responded" ? indigo[900] : "#ff004d",
                      }}
                    >
                      {active.status == "responded" ? <MdMarkEmailRead /> : <MdMarkEmailUnread />}
                    </Avatar>
                  }
                  title={active.title}
                  subheader={new Date(active.created_at).toDateString()}
                />
              </Box>

              <CardContent className="bt">
                <Box p={2} pl={3} color={"#014361"} className="bb">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: active.body,
                    }}
                  />
                </Box>
                <Box p={2} pl={3} color={"#014361"} className="bb">
                  {active.attachments && active.attachments.map((i, idx) => (
                    <a className='btn btn-default' href={i.url}>
                      <i className='fa fa-file m-r-md' />
                      <b> Download Attachment </b>
                    </a>
                  ))}
                </Box>

                {active.status !== "responded" ? (
                  <MessageTemplate
                    id={active.id}
                    dispatch={props.dispatch}
                    flashHandler={(m) => setFlashMessage({ ...m })}
                    questions={[...active.questions]}
                  />
                ) : (
                  <RespondedTemplate questions={[...active.questions]} date={null} />
                )}
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <BottomNavigation
          activeStep={activeStep}
          disableNext={props.messages.length - 1}
          steps={props.messages.length}
          variant="dots"
          handleStep={(step) => {
            step > activeStep ? handleNext() : handleBack();
          }}
        />
      </>
    );
  };

  return (
    <>
      {flashMessage && (
        <Flash
          flash={flashMessage}
          showButton={flashMessage && flashMessage.success ? true : false}
          handleClose={(e) => {
            if (flashMessage && flashMessage.success) {
              props.dispatch({ type: "remove_active_message", payload: active.id });
              setFlashMessage(null);
            } else {
              setFlashMessage(null);
            }
          }}
        />
      )}
      {active && !noMessages && <Carousel />}

      {!active && noMessages && (
        <CardComponent
          media={<MdMailOutline style={{ fontSize: "5em" }} />}
          message={CONST.NO_ADDITIONAL_MESSAGES}
        />
      )}
    </>
  );
}

export default AdditionalMessagesPage;
